import { Paper, Skeleton } from '@mui/material';

export const ExportItemSkeleton = () => {
  return (
    <Paper
      sx={{
        backgroundColor: 'gx.tileLight',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5
      }}
    >
      <Skeleton
        height='14px'
        width='25%'
      />
      <Skeleton
        height='14px'
        width='50%'
      />
      <Skeleton
        height='14px'
        width='50%'
      />
      <Skeleton
        height='14px'
        width='50%'
      />
      <Skeleton height='14px' />
      <Skeleton height='14px' />
      <Skeleton height='14px' />
    </Paper>
  );
};
